<template>
  <div class="body pt-3">
    <div class="wrapper mx-auto">
      <div class="text-end mb-3">
        <router-link :to="{name: 'compare-client-perf', query: $route.query}" class="el-button el-button--primary el-button--mini text-decoration-none" target="_blank">开始对比</router-link>
      </div>

      <head-card :data="perf_second_data" />

      <overview ref="overviewRef" :data="perf_second_data" :testInfo0="testInfo0" :testInfo2="testInfo2" :testInfo3="testInfo3" :labelInfo="labelInfo" :testInfoList="testInfoList" @checked-change="onCheckedChange" />

      <fps ref="fpsRef" :perf_second_data="perf_second_data" :testInfo3="testInfo3" :chartSettings="chartSettings" />
      
      <thread v-if="cpu_by_frame?.series?.length" ref="threadRef" :perf_second_data="perf_second_data" :chartSettings="chartSettings" :cpu_by_frame="cpu_by_frame" />
      
      <cpu ref="cpuRef" :testInfo3="testInfo3" :testInfo="testInfo" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />
      
      <memory ref="memoryRef" :testInfo3="testInfo3" :testInfo="testInfo" :memNewFieldsData="memNewFieldsData" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />
      
      <gpu ref="gpuRef" :testInfo3="testInfo3" :testInfo="testInfo" :gpuNewFieldsData="gpuNewFieldsData" :testInfo0="testInfo0" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <network ref="networkRef" :testInfo3="testInfo3" :testInfo="testInfo" :testInfo0="testInfo0" :testInfo2="testInfo2" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <temperature ref="temperatureRef" :testInfo3="testInfo3" :testInfo="testInfo" :testInfo0="testInfo0" :testInfo2="testInfo2" :labelInfo="labelInfo" :selectedRow="selectedRow" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <thermalStatus ref="thermalStatusRef" :testInfo3="testInfo3" :testInfo="testInfo" :testInfo0="testInfo0" :testInfo2="testInfo2" :labelInfo="labelInfo" :selectedRow="selectedRow" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <brightness ref="brightnessRef" :testInfo3="testInfo3" :testInfo="testInfo" :testInfo0="testInfo0" :testInfo2="testInfo2" :labelInfo="labelInfo" :selectedRow="selectedRow" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <battery ref="batteryRef" :testInfo3="testInfo3" :testInfo="testInfo" :testInfo0="testInfo0" :testInfo2="testInfo2" :labelInfo="labelInfo" :selectedRow="selectedRow" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <mono v-if="showMono" ref="monoRef" :testInfo="testInfo3" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <render-trend v-if="showRenderTrend" ref="renderTrendRef" :testInfo="testInfo3" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <cswitch v-if="isIphone" ref="cswitchRef" :testInfo3="testInfo3" :testInfo="testInfo" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <wakeups v-if="isIphone" ref="wakeupsRef" :testInfo3="testInfo3" :testInfo="testInfo" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <custom v-if="customNoEmpty" ref="customRef" :testInfo0="testInfo0" :testInfo2="testInfo2" :testInfo3="testInfo3" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <custom-data v-if="project_id == 59" ref="customdataRef" :testInfo3="testInfo3" :testInfo="testInfo" :customNewFieldsData="customNewFieldsData" :chartSettings="chartSettings" :perf_second_data="perf_second_data" />

      <div class="footer" style="margin-top: 130px;">
        Copyright&ensp;©&ensp;2021
        &ensp;品质管理部成都二组.&ensp;自动化平台&ensp;企业微信联系：<span
          >pagezhang,&ensp;blackcheng</span
        >
      </div>

      <screen-shots ref="screenShots" :perf_second_data="perf_second_data" />
      <dialog-label ref="dialogLabel" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {ref, computed} from 'vue'
import {useRoute} from 'vue-router'
import * as echarts from 'echarts'
import {allChart, sleep} from './common.js'
import HeadCard from './head-card.vue'
import Overview from './overview.vue'
import DialogLabel from './dialog-label.vue'
import Fps from './modules/fps.vue'
import Thread from './modules/thread.vue'
import Cpu from './modules/cpu.vue'
import Memory from './modules/memory.vue'
import Gpu from './modules/gpu.vue'
import Network from './modules/network.vue'
import Temperature from './modules/temperature.vue'
import ThermalStatus from './modules/thermalStatus.vue'
import Brightness from './modules/brightness.vue'
import Battery from './modules/battery.vue'
import Mono from './modules/mono.vue'
import RenderTrend from './modules/render-trend.vue'
import Cswitch from './modules/cswitch.vue'
import Wakeups from './modules/wakeups.vue'
import Custom from './modules/custom.vue'
import CustomData from './modules/custom-data.vue'
import ScreenShots from './screen-shots.vue'

const useFields = { //图表上方的字段
  data() {
    return {
      fieldDataSeq: 0,
      fpsNewFields: [
        "MedRange(FPS)[%]",
        "Median(FPS)",
        "1%Low(FPS)",
        "Avg(FPS+InterFrame)",
        "Avg(FTime)",
        //"Avg(InterFrame)",
        "Jank(/10min)",
        "BigJank(/10min)",
        "SmallJank(/10min)",
        "Delta(FTime)>100ms[/h]",
        "Drop(FPS)[/h]",
        "FTime>=100[%]",
        "Smooth",
        "Std(FPS)",
        "Std(FTime)",
        "Stutter[%]",
        "Var(FTime)",
      ],
      fpsNewFieldsData: [],
      memNewFields: [
        "avg_swap",
        "avg_vss",
        "Avg(Memory)[MB]",
        "Avg(Memory+Swap)[MB]",
        //"Peak(Memory)[MB]",
        "Peak(Memory+Swap)[MB]",
      ],
      memNewFieldsData: [],
      customNewFields: [
        //"SMG-DrawCall,DrawCall",
        "SMG-FPS,FPS",
        "SMG-FrameTime,Frame",
        "SMG-FrameTime,GPU",
        "SMG-FrameTime,GT",
        "SMG-FrameTime,RHI",
        "SMG-FrameTime,RT",
        "SMG-ObjectCount,ObjectCount",
        //"SMG-Primitives,Primitives",
      ],
      customNewFieldsData: [],
      netNewFields: [
        "(Recv+Send)[KB/10min]",
        "(Recv+Send)[KB/s]",
        "Recv[KB/10min]",
        "Send[KB/10min]",
      ],
      netNewFieldsData: [],
      gpuNewFields: [
        "GPU_ALU_EFU_ALU_Fragment",
        "GPU_ALU_EFU_ALU_Vertex",
        "GPU_ALU_EFU_EFU_Fragment",
        "GPU_ALU_EFU_EFU_Vertex",
        "GPU_General_Busy",
        "GPU_General_CP_Overhead",
        "GPU_General_Clocks",
        "GPU_General_GPU_Bus_Busy",
        "GPU_Memory_Stats_Avg_Bytes_Fragment",
        "GPU_Memory_Stats_Avg_Bytes_Vertex",
        "GPU_Memory_Stats_Avg_Memory_Latency_Cycles",
        "GPU_Memory_Stats_Read_Total",
        "GPU_Memory_Stats_SP_Memory_Read",
        "GPU_Memory_Stats_Texture_Memory_Read_BW",
        "GPU_Memory_Stats_UBWC_Texture_Memory_Read_BW",
        "GPU_Memory_Stats_Write_Total",
        "GPU_Preemption_Avg_Preemption_Delay",
        "GPU_Preemption_Avg_Preemption_Restore_Time",
        "GPU_Preemption_Avg_Preemption_Save_Time",
        "GPU_Preemption_Preemptions",
        "GPU_Primitive_Processing_Average_Polygon_Area",
        "GPU_Primitive_Processing_Average_Vertices",
        "GPU_Primitive_Processing_Pre-clipped_Polygons",
        "GPU_Primitive_Processing_Prims_Clipped",
        "GPU_Primitive_Processing_Prims_Trivially_Rejected",
        "GPU_Primitive_Processing_Reused_Vertices",
        "GPU_Shader_Alloc_Time_ALUs_Working",
        "GPU_Shader_Alloc_Time_Compute",
        "GPU_Shader_Alloc_Time_EFUs_Working",
        "GPU_Shader_Alloc_Time_Shading_Fragments",
        "GPU_Shader_Alloc_Time_Shading_Vertices",
        "GPU_Shader_Precision_Fragment_ALU_Instructions_Half",
        "GPU_Shader_Precision_Fragment_EFU_Instructions",
        "GPU_Shader_Use_Shader_ALU_Capacity_Utilized",
        "GPU_Shader_Use_Shaders_Busy",
        "GPU_Stalls_Instruction_Cache_Miss",
        "GPU_Stalls_L1_Texture_Cache_Miss_Per_Pixel",
        "GPU_Stalls_Shaders_Stalled",
        "GPU_Stalls_Stalled_on_System_Memory",
        "GPU_Stalls_Texture_Fetch_Stall",
        "GPU_Stalls_Texture_L1_Miss",
        "GPU_Stalls_Texture_L2_Miss",
        "GPU_Stalls_Vertex_Fetch_Stall",
        "GPU_Texture_Filterd_Anisotropic_Filtered",
        "GPU_Texture_Filterd_Linear_Filtered",
        "GPU_Texture_Filterd_Nearest_Filtered",
        "GPU_Texture_Filterd_Texture_Pipes_Busy",
        "MAX_GPU_ALU_EFU_ALU_Fragment",
        "MAX_GPU_ALU_EFU_ALU_Vertex",
        "MAX_GPU_ALU_EFU_EFU_Fragment",
        "MAX_GPU_ALU_EFU_EFU_Vertex",
        "MAX_GPU_General_Busy",
        "MAX_GPU_General_CP_Overhead",
        "MAX_GPU_General_Clocks",
        "MAX_GPU_General_GPU_Bus_Busy",
        "MAX_GPU_Memory_Stats_Avg_Bytes_Fragment",
        "MAX_GPU_Memory_Stats_Avg_Bytes_Vertex",
        "MAX_GPU_Memory_Stats_Avg_Memory_Latency_Cycles",
        "MAX_GPU_Memory_Stats_Read_Total",
        "MAX_GPU_Memory_Stats_SP_Memory_Read",
        "MAX_GPU_Memory_Stats_Texture_Memory_Read_BW",
        "MAX_GPU_Memory_Stats_UBWC_Texture_Memory_Read_BW",
        "MAX_GPU_Memory_Stats_Write_Total",
        "MAX_GPU_Preemption_Avg_Preemption_Delay",
        "MAX_GPU_Preemption_Avg_Preemption_Restore_Time",
        "MAX_GPU_Preemption_Avg_Preemption_Save_Time",
        "MAX_GPU_Preemption_Preemptions",
        "MAX_GPU_Primitive_Processing_Average_Polygon_Area",
        "MAX_GPU_Primitive_Processing_Average_Vertices",
        "MAX_GPU_Primitive_Processing_Pre-clipped_Polygons",
        "MAX_GPU_Primitive_Processing_Prims_Clipped",
        "MAX_GPU_Primitive_Processing_Prims_Trivially_Rejected",
        "MAX_GPU_Primitive_Processing_Reused_Vertices",
        "MAX_GPU_Shader_Alloc_Time_ALUs_Working",
        "MAX_GPU_Shader_Alloc_Time_Compute",
        "MAX_GPU_Shader_Alloc_Time_EFUs_Working",
        "MAX_GPU_Shader_Alloc_Time_Shading_Fragments",
        "MAX_GPU_Shader_Alloc_Time_Shading_Vertices",
        "MAX_GPU_Shader_Precision_Fragment_ALU_Instructions_Half",
        "MAX_GPU_Shader_Precision_Fragment_EFU_Instructions",
        "MAX_GPU_Shader_Use_Shader_ALU_Capacity_Utilized",
        "MAX_GPU_Shader_Use_Shaders_Busy",
        "MAX_GPU_Stalls_Instruction_Cache_Miss",
        "MAX_GPU_Stalls_L1_Texture_Cache_Miss_Per_Pixel",
        "MAX_GPU_Stalls_Shaders_Stalled",
        "MAX_GPU_Stalls_Stalled_on_System_Memory",
        "MAX_GPU_Stalls_Texture_Fetch_Stall",
        "MAX_GPU_Stalls_Texture_L1_Miss",
        "MAX_GPU_Stalls_Texture_L2_Miss",
        "MAX_GPU_Stalls_Vertex_Fetch_Stall",
        "MAX_GPU_Texture_Filterd_Anisotropic_Filtered",
        "MAX_GPU_Texture_Filterd_Linear_Filtered",
        "MAX_GPU_Texture_Filterd_Nearest_Filtered",
        "MAX_GPU_Texture_Filterd_Texture_Pipes_Busy",
        "MAX_Shader_Processing_Fragment_Instructions",
        "MAX_Shader_Processing_Fragment_Interpolation_Instructions",
        "MAX_Shader_Processing_Fragments_Shaded",
        "MAX_Shader_Processing_Interpolation_Instructions_Fragment",
        "MAX_Shader_Processing_Textures_Fragment",
        "MAX_Shader_Processing_Textures_Vertex",
        "MAX_Shader_Processing_Vertex_Instructions",
        "MAX_Shader_Processing_Vertices_Shaded",
        "Shader_Processing_Fragment_Instructions",
        "Shader_Processing_Fragment_Interpolation_Instructions",
        "Shader_Processing_Fragments_Shaded",
        "Shader_Processing_Interpolation_Instructions_Fragment",
        "Shader_Processing_Textures_Fragment",
        "Shader_Processing_Textures_Vertex",
        "Shader_Processing_Vertex_Instructions",
        "Shader_Processing_Vertices_Shaded",
      ],
      gpuNewFieldsData: [],
    }
  },

  computed: {

  },

  methods: {
    async fetchFieldsData() { //图表上方的字段数据
      const seq = ++this.fieldDataSeq
      const {data} = await axios.post('performance/label_avg_data/', {
        project: this.project,
        id_test: this.id_test,
        id_label: this.getIdLabelParam(),
      })
      if (seq === this.fieldDataSeq) { //丢弃过期响应，防止快速勾选时旧数据覆盖新数据
        this.testInfo3 = data
      }
    },

    getFieldsData(fields, row) {
      return fields.map(field => {
        return {
          label: field,
          value: row?.[field]
        }
      }).filter(item => item.value)
    },

    getNewFields(tagName = 'All') {
      const row = this.testInfoList.find(item => item.tagName == tagName)

      this.fpsNewFieldsData = this.getFieldsData(this.fpsNewFields, row)
      this.memNewFieldsData = this.getFieldsData(this.memNewFields, row)
      this.customNewFieldsData = this.getFieldsData(this.customNewFields, row)
      this.netNewFieldsData = this.getFieldsData(this.netNewFields, row)
      this.gpuNewFieldsData = this.getFieldsData(this.gpuNewFields, row)
    },

    async getPerfInfo() { //图表上方的字段数据
      const {data} = await axios(`performance/perf_info/?id_test=${this.id_test}`)

      for (let i in data) {
        if (data[i] === null) {
          data[i] = "-";
        }
      }
      this.testInfo2 = data
    },
  }
}

const useChart = {
  data() {
    return {
      chartSettings: {
        // dataZoom: [
        //   // {
        //   //   type: "slider",
        //   //   start: 0,
        //   //   end: 100,
        //   //   height: 14,
        //   //   fillerColor: "#4371fd",
        //   //   showDataShadow: false,
        //   // },
        // ],
        dataZoom: [
          //      {
          //   show: true,
          //   realtime: true,
          //   start: 0,
          //   //  left: 50, //左边的距离
          //   //     right: 40, //右边的距离
          //       bottom: 40, //右边的距离
          //          height: 14, //组件高度
          //   xAxisIndex: [0],
          //   handleColor: "#ddd", //h滑动图标的颜色
          //       handleStyle: {
          //         borderColor: "#cacaca",
          //         borderWidth: "1",
          //         shadowBlur: 2,
          //         background: "#ddd",
          //         shadowColor: "#ddd",
          //       },
          // },
          // {
          //   type: 'inside',
          //   realtime: true,
          //   start:0,
          //   disabled: true,
          // },
          //给x轴设置滚动条
          {
            start: 0,
            end: 100,
            // end: 100 - 1500 / 31, //默认为100
            type: "slider",
            yAxisIndex: "false",
            show: true,
            xAxisIndex: [0],
            // handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 14, //组件高度
            // left: 50, //左边的距离
            // right: 40, //右边的距离
            bottom: 40, //右边的距离
            handleColor: "#ddd", //h滑动图标的颜色
            handleStyle: {
              borderColor: "#cacaca",
              borderWidth: "1",
              shadowBlur: 2,
              background: "#ddd",
              shadowColor: "#ddd",
            },
            fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                //给第一个设置0，第四个设置1，就是垂直渐变
                offset: 0,
                color: "#1eb5e5",
              },
              {
                offset: 1,
                color: "#5ccbb1",
              },
            ]),
            backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
            showDataShadow: false, //是否显示数据阴影 默认auto
            // showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
            handleIcon:
              "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
            filterMode: "filter",
          },
          //下面这个属性是里面拖到
          {
            type: "inside",
            show: true,
            xAxisIndex: [0],
            // zoomLock: false,
            disabled: true, // 禁用鼠标滚动缩放
            //  start: 0,//默认为1
            //  end: 100-1500/31,//默认为100
          },
        ],

        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          className: 'echarts-tooltip',
        },
        legend: {
          type: "scroll",
          y: "bottom",
        },
        grid: {
          left: 50,
          right: 50,
          bottom: "25%",
          top: "25%",
          // containLabel: true,    死都别加
        },
        yAxis: {
          type: "value",
        },
        itemStyle: {
          normal: {
            color: "#3ba272",
            lineStyle: {
              width: 1, // 正常时的折线宽度
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        itemStyle2: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        // timeline: {
        //   lineStyle: {
        //     width: 2,
        //   },
        // },
        // series: [
        //     {
        //         name: '用电量',
        //         type: 'line',
        //         smooth: true,
        //         markArea: {
        //             data: [
        //                 [{
        //                     name: '早高峰',
        //                     xAxis: 20
        //                 }, {
        //                     xAxis: 30
        //                 }]
        //             ]
        //         }
        //     }
        // ],
      },
      zoomInfo: {
        startValue: null,
        endValue: null,
      },
    }
  },

  provide() {
    return {
      saveZoomInfo: this.saveZoomInfo,
    }
  },

  methods: {
    saveZoomInfo({start, end, startValue, endValue} = {}) { //保存滚动条的区间信息
      this.chartSettings.dataZoom[0].start = start //百分比值
      this.chartSettings.dataZoom[0].end = end
      this.zoomInfo.startValue = startValue //x轴坐标值
      this.zoomInfo.endValue = endValue
    },
  }
}

const useRect = { //框选、标签相关功能
  components: {DialogLabel},

  data() {
    return {
      rect: {
        visibleRect: false,
        rectLeft: 0,
        rectWidth: 0,
        rectTop: 100,
        rectHeight: 200,
        startXIndex: null,
        endXIndex: null,
        startXValue: null,
        endXValue: null,
        isClick: true,  //点击还是框选
      },
    }
  },

  provide() {
    return {
      rect: this.rect,
      showDialogLabel: this.showDialogLabel,
    }
  },

  methods: {
    showDialogLabel() {
      this.$refs.dialogLabel.show()
    },
  }
}

const useLabel = { //标签相关功能
  data() {
    return {
      labelInfo: {},
      labels: {
        value: []
      },
    }
  },

  computed: {
    testInfoList() {
      const data = this.labelInfo?.filter(item => item.is_group === false)

      for (let i = 0; i < data.length; i++) {
        for (let j in data[i]) {
          if (data[i][j] === null) {
            data[i][j] = "-";
          }
        }
      }

      return data
    },

    testInfo() {
      if (this.project === 27) {
        return this.labelInfo.filter(
          (item) => item.id_label === "Battle" && item.is_group === true
        )[0];
      } else {
        return this.labelInfo.filter(
          (item) => item.is_group === false
        )[0];
      }
    },

    allLabels() {
      return this.perf_second_data?.['每秒数据']?.rows?.x || []
    },
  },

  provide() {
    return {
      labelInfo: this.labelInfo,
      getIdLabelParam: this.getIdLabelParam,
      onSelectLabel: this.onSelectLabel,
      labels: this.labels,
      setLabels: this.setLabels,
      updateCurLabels: this.updateCurLabels,
    }
  },

  methods: {
    async onSelectLabel() { //概览标签表格勾选时
      this.handleFields()
      await this.getData()
      this.initCharts()
      this.$refs.screenShots?.init()
    },

    async getLabelsData() { //概览标签表格数据
      const {project, id_test} = this.$route.query
      const {data} = await axios(`performance/label_info/?project=${project}&id_test=${id_test}`)
      this.labelInfo = data
    },

    getIdLabelParam() {
      const selectedRow = this.$refs.overviewRef?.selectedRow
      const labels = selectedRow?.map(item => item.id_label)
      if (labels.includes('all')) {
        return 'all'
      } else {
        return labels?.join('|')
      }
    },

    getXPixel(xValue) {
      //return allChart[this.chartKey].convertToPixel({xAxisIndex: 0}, xValue)
      return allChart.fps_line_chart.convertToPixel({xAxisIndex: 0}, xValue)
    },

    updateLabelsPos() { //更新当前显示的所有标签的位置
      const labels = this.labels.value
      labels.forEach((item, index) => {
        const nextItem = labels[index + 1]

        if (index === 0 ) { //如果是第一个标签
          item.startleftVal = this.chartSettings.grid.left
        } else {
          item.startleftVal = this.getXPixel(item.timeline[0])
        }
        item.startLeft = `${item.startleftVal}px`

        if (index === labels.length - 1) { //如果是最后一个标签
          item.endLeftVal = 1540 - this.chartSettings.grid.right
        } else {
          if (nextItem) {
            item.endLeftVal = this.getXPixel(nextItem.timeline[0])
          } else {
            item.endLeftVal = this.getXPixel(item.timeline[item.timeline.length - 1])
          }
        }

        item.widthVal = item.endLeftVal - item.startleftVal
        item.width = `${item.widthVal}px`
      })
    },

    updateCurLabels({startValue, endValue} = {}) {
      const startLabelIndex = this.allLabels.findIndex(item => item.timeline.includes(startValue))
      const endLabelIndex = this.allLabels.findIndex(item => item.timeline.includes(endValue))

      this.labels.value = this.allLabels.slice(startLabelIndex, endLabelIndex + 1)
      this.updateLabelsPos()
    }
  }
}

export default {
  mixins: [useFields, useChart, useRect, useLabel],

  components: {HeadCard, Overview, Fps, Thread, Cpu, Memory, Gpu, Network, Temperature, ThermalStatus, Brightness, Battery, Wakeups, CustomData, Custom, Cswitch, RenderTrend, Mono, ScreenShots},

  data() {
    return {
      perf_second_data: {},
      testInfo2: {},
      testInfo3: {},
      labelInfo: [],
      cpu_by_frame: {},
      injectObj: {
        isAllChecked: true,
      }
    }
  },

  computed: {
    project_id() {
      return this.$route.query.project
    },

    project() {
      return this.$route.query.project
    },

    id_test() {
      return this.$route.query.id_test
    },

    testInfo0() {
      return this.perf_second_data?.['测试信息']
    },

    selectedRow() {
      return this.$refs.overviewRef?.selectedRow
    },

    chartDatacustom() {
      return this.perf_second_data?.['自定义数据']
    },

    customNoEmpty() {
      return this.chartDatacustom?.rows?.i?.length
    },

    isIphone() {
      return this.testInfo0?.device?.toUpperCase()?.indexOf('IPHONE') != -1
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows
    },

    // chartDataDrawCall() {
    //   return this.perf_second_data?.drawcall
    // },

    // chartDataTriangle() {
    //   return this.perf_second_data?.triangle
    // },

    chartDataMonoMem() {
      return this.perf_second_data?.['Mono使用率']
    },

    showRenderTrend() {
      return true
      //return this.secondData?.DrawCall?.length || this.secondData?.Triangle?.length
    },

    showMono() {
      return this.chartDataMonoMem?.rows?.timeline?.length
    },
  },

  provide() {
    return {
      initAll: this.initAll,
      perf_second_data: this.perf_second_data,
      injectObj: this.injectObj,
      showScreenShot: this.showScreenShot,
      hasData: this.hasData,
    }
  },

  async mounted() {
    this.initAll(true)
  },

  methods: {
    async initAll(isMounted) {
      //获取标签数据
      await this.getLabelsData()
      this.$refs.overviewRef?.init()
      this.handleFields()

      await this.getData()
      this.initCharts(isMounted)
      this.$refs.screenShots?.init()
    },

    showScreenShot() {
      //console.log('showScreenShot', this.$refs.screenShots?.showScreenShot)
      return this.$refs.screenShots?.showScreenShot
    },

    handleFields() {
      this.getNewFields()
      this.getPerfInfo()
      this.fetchFieldsData()
    },

    initChartLabels(isMounted) {
      if (isMounted) {
        this.labels.value = this.allLabels
        this.updateLabelsPos()
      } else {
        this.updateCurLabels(this.zoomInfo)
      }
    },

    async initCharts(isMounted) {
      await this.$nextTick()
      await this.getdeepCpuByFrame()
      this.$refs.fpsRef?.init(isMounted)
      this.$refs.threadRef?.init(isMounted)
      this.$refs.cpuRef?.init(isMounted)
      this.$refs.memoryRef?.init(isMounted)
      this.$refs.gpuRef?.init(isMounted)
      this.$refs.networkRef?.init(isMounted)
      
      this.$refs.temperatureRef?.init(isMounted)
      this.$refs.thermalStatusRef?.init(isMounted)
      this.$refs.brightnessRef?.init(isMounted)
      this.$refs.batteryRef?.init(isMounted)

      this.$refs.monoRef?.init(isMounted)
      this.$refs.renderTrendRef?.init(isMounted)
      this.$refs.cswitchRef?.init(isMounted)
      this.$refs.wakeupsRef?.init(isMounted)
      this.$refs.customRef?.init(isMounted)
      this.$refs.customdataRef?.init(isMounted)

      this.initChartLabels(isMounted)
      if (isMounted) {
        await sleep(0)
        echarts.connect(Object.values(allChart).filter(item => item))
      }
    },

    async getData() { //图表和标签数据
      const {project, id_test} = this.$route.query,
        {data} = await axios('performance/perf_detail/', {
          params: {
            project,
            id_test,
            id_label: this.getIdLabelParam(),
          }
        })
      this.perf_second_data = data
    },

    async getdeepCpuByFrame() { //线程函数图表数据
      const {data} = await axios('deep_performance/cpu_func_by_frame/', {
        params: {
          project: this.project,
          id_test: this.id_test,
        }
      })
      this.cpu_by_frame = data
    },

    onCheckedChange(val) {
      this.injectObj.isAllChecked = val
    },

    hasData(arr = []) { //判断图表是否有数据
      let result = false

      if (this.secondData?.timeline?.length) {
        for (let field of arr) {
          if (this.secondData?.[field]?.filter(item => item || item === 0)?.length) {
            result = true
            break
          }
        }
      }

      return result
    },
  }
}
</script>

<style scoped>
.body {
  background: #f5f6fa;
}

.wrapper {
  width: 1600px;
}

.footer {
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #acb0bf;
}

.footer span {
  color: #1a1d27;
  cursor: pointer;
}

.body :deep(.echarts-tooltip) {
  z-index: 9!important;
}
</style>